import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Settlement } from 'ha/services/apiV2/types/Settlement';
import { APIV2_URL } from '../constants';

export default (makeCall: MakeCall) => (reference: string) =>
  makeCall<Settlement>('GET', `${APIV2_URL}/payment/settlement/${reference}`);
